module.exports = __webpack_public_path__ + "static/media/venus.50fb39f4.webp";